module.exports = __webpack_public_path__ + "static/media/loxone-history-2.6835d9ff.png";